import React from 'react'

import { NumberString } from '@fourthwall/components'
import type { AnalyticsRowsProps } from '@fourthwall/module-analytics'

import { OfferLink } from '../../../components/OfferLink/OfferLink'
import { title } from '../../../consts'
import type { TopOfferAnalytics } from '../AnalyticsOverview.types'

export const mapOffersToAnalyticsRows = (
  topOfferAnalytics: TopOfferAnalytics,
): AnalyticsRowsProps['rows'] => {
  if (!topOfferAnalytics) return []

  return topOfferAnalytics.map((offer) => ({
    label: <OfferLink name={offer.name} label={title} id={offer.offerId} status={offer.status} />,
    value: <NumberString value={offer.unitsSold} />,
  }))
}
